import { configureStore } from '@reduxjs/toolkit';
import { cellSelectionReducer } from '../cellSelection/redux/cellSelectionSlice';
export const createCellSelectionStore = () => configureStore({
  reducer: {
    cellSelection: cellSelectionReducer
  },
  devTools: {
    name: 'customer-data-table-cell-selection'
  }
});